import React, { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import CompanyAutocomplete from './CompanyAutocomplete';

const CHANGE_COMPANY_WARNING = `Do you want to transfer notes to new company or erase the device notes?`;

const BulkBoxAssignmentModal = ({ isOpen, onCancel, onConfirm }) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, submitCount, isSubmitted },
  } = useForm();

  const companies = useSelector(state => state.AppState.companies);
  const boxGroup = useSelector(state => state.UIState.epikBoxes.selectedBoxes);

  useEffect(() => {
    if (isSubmitted && !Object.keys(errors)) {
      console.log(errors, getValues());
      toast.error('Please fix error and submit again');
    }
  }, [submitCount]);

  register('assignedTo', { required: true });

  function onSubmit(values) {
    const payload = {
      boxGroup,
      assignedTo: values.assignedTo.suggestion._id,
      companyName: values.assignedTo.suggestion.name,
      notifyNumbers: values.notifyNumbers.split(','),
      notifyEmails: values.notifyEmails.split(','),
      monitor: values.monitor,
      action: values?.assignedTo?.action,
    };
    onConfirm(payload);
  }

  return (
    <div>
      <Modal isOpen={isOpen} toggle={onCancel}>
        <ModalHeader toggle={onCancel}>Import Edge Device</ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="d-flex flex-wrap my-2">
              <span className="text-nowrap mr-2 mt-2">Company :</span>
              <div className="flex-grow-1">
                <CompanyAutocomplete
                  searchTerm={getValues('assignedTo')?.value || ''}
                  companies={companies.docs}
                  onChange={company =>
                    setValue('assignedTo', company, {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    }) 
                  }
                  showWarning
                  warningText={CHANGE_COMPANY_WARNING}
                />
                {errors.assignedTo && (
                  <span className="d-block text-danger py-1">Invalid Company</span>
                )}
              </div>
            </div>
            <div className="d-flex flex-wrap my-2">
              <span className="text-nowrap mr-2 mt-2">Notification Email(s) :</span>
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control"
                  {...register('notifyEmails', {
                    validate: value =>
                      !value ||
                      value
                        ?.split(',')
                        .every(value =>
                          value.match(
                            /[A-Za-z0-9!#$%&'*+-=?^_`{|}~]+@[A-Za-z0-9-]+(.[A-Za-z0-9-]+)*/g,
                          ),
                        ),
                  })}
                />
                {errors.notifyEmails && (
                  <span className="d-block text-danger py-1">Invalid Email</span>
                )}
              </div>
            </div>
            <div className="d-flex flex-wrap my-2">
              <span className="text-nowrap mr-2 mt-2">Notification Number(s) :</span>
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control"
                  {...register('notifyNumbers', {
                    validate: value =>
                      !value || value?.split(',').every(value => value.match(/^[0-9]+$/g)),
                  })}
                />
                {errors.notifyNumbers && (
                  <span className="d-block text-danger py-1">Invalid number</span>
                )}
              </div>
            </div>
            <div className="d-flex flex-wrap my-2">
              <span className="text-nowrap mr-2 mt-1">Monitoring :</span>
              <label className="custom-control custom-checkbox mb-0">
                <input type="checkbox" className="custom-control-input" {...register('monitor')} />
                <span className="custom-control-label"></span>
              </label>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmit)}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BulkBoxAssignmentModal;
